import { isDirectChild } from '@studiometa/js-toolkit';
import { Frame as FrameCore } from '@studiometa/ui';
import FrameScrolling from '../atoms/FrameScrolling.js';

/**
 * Frame with animation on FrameAnchor loading
 */
export default class Frame extends FrameCore {
  static config = {
    ...FrameCore.config,
    components: {
      FrameScrolling,
      ...FrameCore.config.components,
    },
  };

  /**
   * mounted
   */
  mounted() {
    this.bindScrollingContent();
    this.$services.disable('ticked');
  }

  /**
   * Prevent click on `FrameAnchor`.
   * @param {number} index
   * @param {MouseEvent} event
   * @returns {Promise}
   */
  async onFrameAnchorClick(index, event) {
    // Prevent propagation of nested frames
    if (!isDirectChild(this, 'Frame', 'FrameAnchor', this.$children.FrameAnchor[index])) {
      return;
    }

    this.$log('onAFrameClick', index, event);
    event.preventDefault();
    const anchor = this.$children.FrameAnchor[index];

    anchor.$el.classList.add('is-loading');

    // Do nothing when clicking links on the same page
    if (anchor.href === window.location.href) {
      return;
    }

    await this.goTo(anchor.href);

    this.bindScrollingContent();

    anchor.$el.classList.remove('is-loading');
  }

  /**
   * mouseenter activate ticked
   */
  onFrameScrollingMouseenter() {
    this.$services.enable('ticked');
  }

  /**
   * mouselefeave disable ticked
   */
  onFrameScrollingMouseleave() {
    this.$services.disable('ticked');
  }

  /**
   * on ticked autoscroll the scrollingContent
   */
  ticked() {
    if (this.scollingContent && this.$services.has('ticked')) {
      this.scollingContent.scrollLeft += 3;
    }
  }

  /**
   * bind scrolling content element to the instance.
   */
  bindScrollingContent() {
    this.$services.disable('ticked');
    this.scollingContent = this.$el.querySelector('.scolling-content');
  }
}
